import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon, useSvgId } from './icon-utils';

export function GenerateInsightIcon({
  className,
  height = 16,
  stroke = IconColors.DarkGrey,
  width = 16,
}: Pick<SimpleIconInterface, 'className' | 'height' | 'width' | 'stroke'>): JSX.Element {
  const clipPathId = useSvgId('generate-insight-clip');

  return (
    <SimpleIcon
      className={className}
      fill="none"
      height={height}
      stroke={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      viewBoxDimensions="0 0 16 16"
      width={width}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path d="M11.0768 2.11945L11.6598 0.70363C11.6927 0.6237 11.7707 0.571533 11.8571 0.571533C11.9435 0.571533 12.0214 0.6237 12.0543 0.70363L12.6373 2.11945C12.8694 2.68308 13.317 3.13064 13.8806 3.36272L15.2964 3.94572C15.3764 3.97862 15.4285 4.05652 15.4285 4.14296C15.4285 4.22941 15.3764 4.3073 15.2964 4.34021L13.8806 4.9232C13.317 5.15528 12.8694 5.60285 12.6373 6.16647L12.0543 7.5823C12.0214 7.66222 11.9435 7.71439 11.8571 7.71439C11.7707 7.71439 11.6927 7.66222 11.6598 7.5823L11.0768 6.16647C10.8448 5.60285 10.3972 5.15528 9.83356 4.9232L8.41774 4.34021C8.33782 4.3073 8.28564 4.22941 8.28564 4.14296C8.28564 4.05652 8.33782 3.97862 8.41774 3.94572L9.83356 3.36272C10.3972 3.13064 10.8448 2.68308 11.0768 2.11945Z" />
        <path d="M6.28557 2.88281C3.08186 3.17152 0.571289 5.86402 0.571289 9.1429C0.571289 12.6144 3.38549 15.4286 6.857 15.4286C10.1359 15.4286 12.8284 12.9181 13.117 9.71433" />
        <path d="M8.57115 12.5715H5.14258" />
        <path d="M6.85693 6.28578C7.01473 6.28578 7.14265 6.15786 7.14265 6.00007C7.14265 5.84228 7.01473 5.71436 6.85693 5.71436" />
        <path d="M6.857 6.28578C6.69921 6.28578 6.57129 6.15786 6.57129 6.00007C6.57129 5.84228 6.69921 5.71436 6.857 5.71436" />
        <path d="M6.85721 12.5715V8.57153H5.71436" />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect fill="white" height="16" width="16" />
        </clipPath>
      </defs>
    </SimpleIcon>
  );
}
